export default "__VITE_ASSET__7e48d2b4__"